import React from 'react';
import {useTranslation} from 'react-i18next';

import {Dropdown} from '@edna/components';
import {Icon, Stack} from '@edna/components/primitives';
import KeyboardArrowDownIcon from '@edna/icons/keyboardArrowDown.svg';

import {EPermission, PermissionGuard} from 'src/containers/User';
import {AnalyticsIcon, EyeIcon, ScenarioIcon, SettingsIcon} from 'src/icons';
import {MESSAGE_MATCHERS_PREFIX, SUPPORT_PREFIX, TRIGGERS_PREFIX} from 'src/paths';

import * as S from './style';

export const SupportPagesSelector: React.FC<{tenantId: string}> = ({tenantId}) => {
  const {t} = useTranslation();
  const templatesLink = `${SUPPORT_PREFIX}/${tenantId}${MESSAGE_MATCHERS_PREFIX}`;
  const reportLink = `${SUPPORT_PREFIX}/${tenantId}/analytics/channels`;
  const scenariosLink = `${SUPPORT_PREFIX}/${tenantId}${TRIGGERS_PREFIX}`;

  return (
    <Dropdown
      placementX="right"
      head={
        <S.SelectorButton appearance="primary" size="S">
          <Stack size="1" direction="ROW" align="center">
            <Icon as={EyeIcon} size="16px" />
            {t('ClientStatus:seeAsClient')}
            <KeyboardArrowDownIcon />
          </Stack>
        </S.SelectorButton>
      }
      overlay={
        <>
          <S.SelectorDropdownItem to={templatesLink}>
            <Icon as={SettingsIcon} size="20px" />
            {t('ClientStatus:clientPages.messageMatchers')}
          </S.SelectorDropdownItem>
          <S.SelectorDropdownItem to={reportLink}>
            <Icon as={AnalyticsIcon} size="20px" />
            {t('ClientStatus:clientPages.report')}
          </S.SelectorDropdownItem>
          <PermissionGuard permissions={EPermission.PERMISSION_TENANT_FLOW_READ}>
            <S.SelectorDropdownItem to={scenariosLink}>
              <Icon as={ScenarioIcon} size="20px" />
              {t('ClientStatus:clientPages.scenarios')}
            </S.SelectorDropdownItem>
          </PermissionGuard>
        </>
      }
    />
  );
};
